import type { RouteRecordRaw } from 'vue-router'

const taskRoutes: RouteRecordRaw[] = [
  {
    path: 'tasks',
    component: () => import('@/pages/approval/layout.vue'),
    meta: { title: '待办与审核' },
    children: [
      {
        path: '',
        name: 'Tasks',
        component: () => import('@/views/Tasks.vue'),
        meta: { title: '我的待办' },
      },
      {
        path: 'approval',
        name: 'ApprovalList',
        component: () => import('@/pages/approval/ApprovalList.vue'),
        meta: { title: '审核中心', requiresPsi: true },
      },
      {
        path: 'approval/flows-prototype',
        name: 'ApprovalFlowPrototype',
        component: () => import('@/pages/approval/ApprovalFlowConfigPrototype.vue'),
        meta: { title: '审核流程', requiresPsi: true },
      },
      {
        path: 'approval/:id',
        name: 'ApprovalDetail',
        component: () => import('@/pages/approval/ApprovalDetail.vue'),
        meta: { title: '审核详情', requiresPsi: true },
      },
    ],
  },
  {
    path: 'tasks/:id',
    name: 'TaskDetail',
    component: () => import('@/views/TaskDetail.vue'),
    meta: { title: '待办详情' },
  },
]

export default taskRoutes
